











import { Vue, Component, Prop } from "@/shared/vuepack";
import Payroll from "./Payroll.vue";
import PayrollOnboardingEdit from "@/employer/components/payrollcalendar/OnboardingEdit.vue";
import { FundingOption, FeatureFlags } from "@/shared/types";
import { ProfileWizardSteps } from "@/employer/types";
import { useUserStore } from "@/shared/store/user";
import { useProfileStore } from "@/employer/store/profile";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";


@Component ({
  components: {
    Payroll,
    PayrollOnboardingEdit
  }
})
export default class PayrollSetup extends Vue {
  shouldShowPayroll = true;
  shouldShowCalendar = false;

  @Prop({required: false})
  forEmployerId: number;

  userStore = useUserStore();
  profileStore = useProfileStore();
  featureFlagStore = useFeatureFlagStore();

  get employerId () { return this.forEmployerId || this.userStore.employerId; }

  @Prop()
  submitButtonText: string;

  @Prop()
  greyBackground: boolean;

  @Prop()
  edit: boolean;

  skipCalendar () {
    return this.featureFlagStore.flags.showFundingMethod
      && (this.profileStore.fundingOption === FundingOption.ErCalculateBendPull
        || this.profileStore.fundingOption === FundingOption.ErCalculateErPush);
  }

  showNextStep () {
    const employerId = this.employerId;

    if (this.skipCalendar()) {
      this.profileStore.saveOnboardProgressComplete({employerId, onboardingStep: ProfileWizardSteps.PayrollSetup})
      .then(() => this.profileStore.setWizardComplete(employerId))
      .then(() => this.completed());
    }
    else {
      this.shouldShowPayroll = false;
      this.shouldShowCalendar = true;
    }
  }

  completed () {
    this.$emit("complete");
  }
}
